import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../../../services/Validator";

export default function ExerciserCorrectionText({isCorrect, correction}) {
    // Used in ExerciserCorrectionModal to display correction
    // only if userAnswer is not correct

    // BUILD
    if (isCorrect === true || isNullOrUndefined(correction))
        return null
    return (
        <div className={"mt-[12px] w-full flex justify-center items-center"}>
            <MathJaxContext>
                <MathJax inline dynamic>
                    <span className="whitespace-pre-line font-bold text-[20px] text-white">
                        {correction}
                    </span>
                </MathJax>
            </MathJaxContext>
        </div>
    )
}